import { formatDateTime, formatUSD } from "@/lib/api";
import { STATUS_STYLES } from "@/lib/ui";

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex font-mono text-[11px] uppercase tracking-wider px-2 py-0.5 border ${STATUS_STYLES[status]}`}>{status}</span>
);

export const RequestHistory = ({ jobs }) => {
  if (!jobs.length) {
    return (
      <div className="border border-dashed border-slate-700 py-16 text-center" data-testid="request-history-empty">
        <p className="font-display text-sm uppercase tracking-widest text-slate-300">No requests yet</p>
        <p className="text-sm text-slate-500 mt-2">Your tow requests will show up here.</p>
      </div>
    );
  }
  return (
    <ul className="space-y-3" data-testid="request-history-list">
      {jobs.map((j) => (
        <li key={j.id} data-testid={`request-history-item-${j.id}`} className="border border-slate-800 bg-[#0A0F1C]/90 p-4 sm:p-5 grid sm:grid-cols-[1fr_auto] gap-3 hover:border-cyan-500/40 transition-colors">
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <StatusBadge status={j.status} testId={`request-status-${j.id}`} />
              <span className="font-mono text-xs text-slate-500">{formatDateTime(j.date_time)}</span>
            </div>
            <p className="mt-2 font-display text-sm uppercase tracking-wider text-slate-100">{j.vehicle_info}</p>
            <p className="mt-1 text-sm text-slate-400 break-words">{j.pickup_location} <span className="text-[#FF007F]">→</span> {j.dropoff_location}</p>
          </div>
          <div className="sm:text-right">
            <p className="font-mono text-xl text-[#00FF66]">{formatUSD(j.towing_fee)}</p>
            {j.distance_miles != null && <p className="font-mono text-xs text-slate-500">{j.distance_miles.toFixed(1)} mi</p>}
          </div>
        </li>
      ))}
    </ul>
  );
};
